module.exports = __webpack_public_path__ + "static/media/8th_B.de75f1c2.png";